import { render, staticRenderFns } from "./FileEditorThemeLibrary.vue?vue&type=template&id=7b850f16&scoped=true"
import script from "./FileEditorThemeLibrary.vue?vue&type=script&lang=js"
export * from "./FileEditorThemeLibrary.vue?vue&type=script&lang=js"
import style0 from "./FileEditorThemeLibrary.vue?vue&type=style&index=0&id=7b850f16&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b850f16",
  null
  
)

export default component.exports